import { useState } from "react";
import { Link } from "react-router-dom";

export default function KnowledgePage() {
  return <>knowledge</>;
}
